import { CaretRightIcon } from '@phosphor-icons/react'
import React from 'react'
import { useTranslation } from 'react-i18next'

import { orderStatusBarIconsMap } from '@/components/business/market-shop/order-status-bar/order-status-bar.constants'
import { OrderStatusBarStatus } from '@/components/business/market-shop/order-status-bar/order-status-bar.types'
import { Icon } from '@/components/ui/icon'
import { Typography } from '@/components/ui/typography'

import * as S from './order-status-bar.styled'

export interface OrderStatusBarProps {
  title: string
  message: string
  status: OrderStatusBarStatus
  onTrackClick?: VoidFunction
}

export const OrderStatusBar = ({ title, message, status, onTrackClick }: OrderStatusBarProps) => {
  const { t } = useTranslation(['market-shop'])

  return (
    <S.Container $status={status}>
      <S.StatusIcon icon={orderStatusBarIconsMap[status]} $status={status} size="2.4rem" />
      <S.Content>
        <Typography size="text-medium" weight="medium" color="black800" whiteSpace="nowrap">
          {title}
        </Typography>
        <Typography size="text-small" weight="medium" color="black500" whiteSpace="nowrap">
          {message}
        </Typography>
      </S.Content>
      {onTrackClick && (
        <S.TrackButton use="unset" size="unset" $status={status} onClick={onTrackClick}>
          {t('market-shop:orderStatusBar.track')}
          <Icon icon={CaretRightIcon} size="1.6rem" />
        </S.TrackButton>
      )}
    </S.Container>
  )
}
